import axios from "axios";
import React, { useEffect, useState } from "react";
import ArticleIcon from "@mui/icons-material/Article";
import PostAddIcon from "@mui/icons-material/PostAdd";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import PersonPinIcon from "@mui/icons-material/PersonPin";
import DescriptionIcon from "@mui/icons-material/Description";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { Button, Modal } from "react-bootstrap";
import MapContainer from "../Components/Stp/Page/MapContainer";
import { APIURL, APIURLCOT } from "../Config";
import { toast } from "react-toastify";
import "./App.css";
import moment from "moment";

export default function ClientDetailCTLoanDetail({ lid }) {
  const token = localStorage.getItem("token");
  const loginType = localStorage.getItem("selectedTab");

  const [showModal, setShowModal] = useState(false);
  const [showModalRemark, setShowModalRemark] = useState(false);
  const [isLoader, setIsLoader] = useState(false);
  const [activeTab, setActiveTab] = useState("personal");
  const [transitionHistroy, setTransitionHistroy] = useState([]);
  const [clientDoc, setClientDoc] = useState([]);
  const [mapValue, setMapValue] = useState("");
  const [ProfileValue, setProfileValue] = useState("");
  const [staffId, setStaffId] = useState("");
  const [newRemark, setNewRemark] = useState("");
  const [mapStatus, setMapStatus] = useState(false);
  const [clientData, setCientData] = useState({});
  const [PersonalData, setPersonalData] = useState({});
  const [eqfexData, setEqfexData] = useState([]);
  const [neighbourData, setneighbourData] = useState([]);
  const [remarkData, setRemarkData] = useState([]);
  const [contectData, setContectData] = useState([]);
  const [docsData, setDocsData] = useState([]);

  const [bankData, setBankData] = useState([]);
  const [creditData, setCreditData] = useState([]);
  const [transitionDataMonthly, setTransitionDataMonthly] = useState([]);
  const [data, setData] = useState([]);
  const [pdData, setpdData] = useState({});
  const [showModals, setShowModals] = useState(false);
  const [mapValues, setMapValues] = useState(null);
  const [mapStatuss, setMapStatuss] = useState(false);

  const handleGeoClick = async (type, identifier) => {
    setMapStatuss("loading");
    setMapValues(null);
    let url = "";

    switch (type) {
      case "latlong":
        url = `${APIURLCOT}/latlong/${identifier}`;
        break;
      case "history":
        url = `${APIURLCOT}/history/${identifier}`;
        break;
      case "latlongapp":
        url = `${APIURLCOT}/latlongapp/${identifier}`;
        break;
      default:
        console.error("Invalid type");
        return;
    }

    try {
      const response = await fetch(url);
      const data = await response.json();

      if (Array.isArray(data)) {
        setMapStatuss(false);

        const coordinates = data.map((item) => ({
          lat: parseFloat(item.latitude),
          lng: parseFloat(item.longitude),
        }));

        // You can use `coordinates` as needed, for example:
        setMapValues(coordinates);
        setMapStatuss(true);
        setShowModals(true);

        // If you want to show multiple markers or something else
      } else {
        const latest = data;

        setMapValues({
          lat: parseFloat(latest.latitude),
          lng: parseFloat(latest.longitude),
        });

        setMapStatuss("loaded");
        setShowModals(true);
      }
    } catch (err) {
      console.error("Error fetching location:", err);
      setMapStatuss("error");
    }
  };

  console.log("loan id::", lid);
  useEffect(() => {
    getTransactionSummery(lid);
    getLoanDetails(lid);
    getClientDoc(lid);
    getNeighbourDetails(lid);
    getEqfexDetails(lid);
    getPersonalDetails(lid);
    getTransationDetails(lid);
    getRemarkDetails(lid);
    getContectDetails(lid);
    getcreditdetails(lid);
    getBankdetail(lid);
  }, [lid]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const getRemarkDetails = (loanId) => {
    setIsLoader(true);
    axios(
      `${
        loginType === "Cashon Tap" ? APIURLCOT : APIURL
      }/getnotRemarks/${loanId}`,
      {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => {
        console.log("::::::123", response.data);
        setIsLoader(false);
        setRemarkData(response.data);
        //  setBorrowerData(response.data?.repayment[0]);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  };
  const getBankdetail = (loanId) => {
    setIsLoader(true);
    axios(
      `${loginType === "Cashon Tap" ? APIURLCOT : APIURL}/bankdetail/${loanId}`,
      {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => {
        console.log("::::::123", response.data);
        setIsLoader(false);
        setBankData(response.data);
        //  setBorrowerData(response.data?.repayment[0]);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  };
  const getcreditdetails = (loanId) => {
    setIsLoader(true);
    axios(
      `${
        loginType === "Cashon Tap" ? APIURLCOT : APIURL
      }/creditdetails/${loanId}`,
      {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => {
        console.log("::::::123", response.data);
        setIsLoader(false);
        setCreditData(response.data);
        //  setBorrowerData(response.data?.repayment[0]);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  };
  const getContectDetails = (loanId) => {
    setIsLoader(true);
    axios(
      `${
        loginType === "Cashon Tap" ? APIURLCOT : APIURL
      }/contactdetail/${loanId}`,
      {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => {
        console.log("::::::123", response.data);
        setIsLoader(false);
        setContectData(response.data);
        //  setBorrowerData(response.data?.repayment[0]);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  };
  const getTransationDetails = (loanId) => {
    setIsLoader(true);
    axios(
      `${
        loginType === "Cashon Tap" ? APIURLCOT : APIURL
      }/getAllMonthStatement/${loanId}/3`,
      {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => {
        console.log("::::::123", response.data);
        setIsLoader(false);
        setTransitionDataMonthly(response.data);

        //  setBorrowerData(response.data?.repayment[0]);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  };
  function getClientDetailsMagic(loanId) {
    setIsLoader(true);

    axios
      .request(`${APIURL}/getClientDetailsMagic/${loanId}`, {
        method: "GET",
        headers: {
          Authentication: token,

          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setData(response?.data);

        setIsLoader(false);

        console.log("response::::", response);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  }
  function getPdDetails(appId) {
    setIsLoader(true);
    setpdData({});

    axios
      .request(`${APIURLCOT}/applicationform/${appId}`, {
        method: "GET",
        headers: {
          Authentication: token,

          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setpdData(response?.data);
        setMapValue(response?.data);
        setIsLoader(false);

        console.log("response::::", response);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  }
  const getLoanDetails = (loanId) => {
    setIsLoader(true);
    axios(
      `${
        loginType === "Cashon Tap" ? APIURLCOT : APIURL
      }/ClientDetails/${loanId}`,
      {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => {
        console.log("::::::123", response.data);
        setIsLoader(false);
        setCientData(response.data);
        getDocsDetails(response.data.appclientid);
        getPdDetails(response.data.appclientid);
        getClientDetailsMagic(response.data.appclientid);

        //  setBorrowerData(response.data?.repayment[0]);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  };
  const getDocsDetails = (loanId) => {
    // setIsLoader(true);
    axios(
      `${
        loginType === "Cashon Tap" ? APIURLCOT : APIURL
      }/allUploadedDocs/${loanId}`,
      {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => {
        console.log("::::::123", response.data);
        setIsLoader(false);
        setDocsData(response.data);
        response.data.map((item, i) => {
          if (item.doctype == "ID Photo") {
            setProfileValue(item.doclink);
          }
        });
        //  setBorrowerData(response.data?.repayment[0]);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  };
  const getPersonalDetails = (loanId) => {
    setIsLoader(true);
    axios(
      `${
        loginType === "Cashon Tap" ? APIURLCOT : APIURL
      }/personaldetail/${loanId}`,
      {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => {
        console.log("::::::123", response.data);
        setIsLoader(false);
        setPersonalData(response.data);
        //  setBorrowerData(response.data?.repayment[0]);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  };
  const getEqfexDetails = (loanId) => {
    setIsLoader(true);
    axios(
      `${
        loginType === "Cashon Tap" ? APIURLCOT : APIURL
      }/equifaxdetail/${loanId}`,
      {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => {
        console.log("::::::123", response.data);
        setIsLoader(false);
        setEqfexData(response.data);
        //  setBorrowerData(response.data?.repayment[0]);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  };
  const getNeighbourDetails = (loanId) => {
    setIsLoader(true);
    axios(
      `${
        loginType === "Cashon Tap" ? APIURLCOT : APIURL
      }/neighbourdetails/${loanId}`,
      {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => {
        console.log("::::::123", response.data);
        setIsLoader(false);
        setneighbourData(response.data);
        //  setBorrowerData(response.data?.repayment[0]);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  };
  const getTransactionSummery = (loanId) => {
    setIsLoader(true);
    axios(
      `${loginType === "Cashon Tap" ? APIURLCOT : APIURL}/SucessTxns/` + loanId,
      {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => {
        let finalArray = [];
        setIsLoader(false);
        console.log("finalArray", finalArray);
        setTransitionHistroy(response.data);
      })

      .catch((error) => {
        console.log("----", error);
        setIsLoader(false);
      });
  };
  const getClientDoc = (loanId) => {
    setIsLoader(true);
    axios(
      `${
        loginType === "Cashon Tap" ? APIURLCOT : APIURL
      }/documentsForReports/${loanId}`,
      {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => {
        console.log(response.data);
        setIsLoader(false);
        setClientDoc(response.data);
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };
  const groLocation = () => {
    // setIsLoader(true);
    setShowModal(true);
    // setMapStatus(true);

    // axios
    //   .request(`${APIURL}/getGeoLocation/${lid}`, {
    //     method: "GET",
    //     headers: {
    //       Authentication: token,
    //       "Content-Type": "application/json",
    //     },
    //   })
    //   .then((response) => {
    //     setIsLoader(false);
    //     console.log("response", response);
    //     // setMapValue(response?.data);
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //     setIsLoader(false);
    //   });
  };

  const handleSubmitRemark = () => {
    if (!staffId) {
      toast.warning("Staff ID is required.");
      return;
    }

    if (!newRemark) {
      toast.warning("Remark is required.");
      return;
    }

    const data = {
      loanid: lid,
      remark: newRemark,
      remarkBy: staffId,
    };
    console.log("data::: ", data);
    axios
      .request(`${APIURLCOT}/addRemarks`, {
        method: "POST",
        data: data,
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setIsLoader(false);
        getRemarkDetails(lid);
        setStaffId("");
        setNewRemark("");
        setShowModalRemark(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  };

  const handleModalClose = () => {
    setShowModal(false);
    setShowModals(false);
  };
  const handleModalRemarkClose = () => {
    setShowModalRemark(false);
  };
  function openJSON(data) {
    const jsonString = JSON.parse(JSON.stringify(data)); // formatted JSON
    const blob = new Blob([jsonString], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank");
  }
  return (
    <div>
      <div className="pt-2">
        <div className="card">
          <div className=" p-3  ">
            {isLoader ? (
              <div className="d-flex justify-content-center">
                <div className="spinner-border text-success" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            ) : (
              <div className="card-body">
                <div className="">
                  <div className="pt-1" style={{ backgroundColor: "#a6df6d" }}>
                    <h5 className="text-center">{clientData.name}</h5>
                  </div>
                  <div className="row ">
                    <div
                      className="col-lg-5 col-md-5 col-sm-12 d-flex mt-5"
                      style={{ justifyContent: "center" }}
                    >
                      <img
                        src={ProfileValue}
                        className=""
                        height="250px"
                        width="250px"
                      />
                    </div>
                    <div
                      className="col-lg-7 col-md-7 col-sm-12 "
                      style={{ fontSize: "14px", marginTop: "30px" }}
                    >
                      <div className="row mt-4">
                        <b className="col-4 col-xs-6">Name </b>
                        <p
                          className="col-8 col-xs-6 mb-1"
                          style={{ fontSize: "14px" }}
                        >
                          {clientData.name || "-"}
                        </p>
                      </div>
                      <div className="row ">
                        <b className="col-4 col-xs-6">Mobile No. </b>
                        <p
                          className="col-8 col-xs-6 mb-1"
                          style={{ fontSize: "14px" }}
                        >
                          {clientData.mobile || "-"}
                        </p>
                      </div>
                      <div className="row">
                        <b className="col-4 col-xs-6">Loan Id </b>
                        <p
                          className="col-8 col-xs-6 mb-1"
                          style={{ fontSize: "14px" }}
                        >
                          {clientData.loanid || "-"}
                        </p>
                      </div>{" "}
                      <div className="row">
                        <b className="col-4 col-xs-6">Status</b>
                        <p
                          className="col-8 col-xs-6 mb-1"
                          style={{ fontSize: "14px" }}
                        >
                          {clientData.loanstatus || "-"}
                        </p>
                      </div>{" "}
                      <div className="row">
                        <b className="col-4 col-xs-6">Type</b>
                        <p
                          className="col-8 col-xs-6 mb-1"
                          style={{ fontSize: "14px" }}
                        >
                          {clientData.type || "-"}
                        </p>
                      </div>{" "}
                      <div className="row">
                        <b className="col-4 col-xs-6">Limit assigned</b>
                        <p
                          className="col-8 col-xs-6 mb-1"
                          style={{ fontSize: "14px" }}
                        >
                          {clientData.limitassigned || "-"}
                        </p>
                      </div>{" "}
                      <div className="row">
                        <b className="col-4 col-xs-6">Limit used</b>
                        <p
                          className="col-8 col-xs-6 mb-1"
                          style={{ fontSize: "14px" }}
                        >
                          {clientData.limitused}
                        </p>
                      </div>{" "}
                      <div className="row">
                        <b className="col-4 col-xs-6 ">Outstanding</b>
                        <p
                          className="col-8 col-xs-6 mb-1"
                          style={{ fontSize: "14px" }}
                        >
                          {clientData.outstanding}
                        </p>
                      </div>{" "}
                      <div className="row">
                        <b className="col-4 col-xs-6">Client id </b>
                        <p
                          className="col-8 col-xs-6 mb-1"
                          style={{ fontSize: "14px" }}
                        >
                          {" "}
                          {clientData.appclientid || "-"}
                        </p>
                      </div>{" "}
                      <div className="row">
                        <b className="col-4 col-xs-6">Branch</b>
                        <p
                          className="col-8 col-xs-6 mb-1"
                          style={{ fontSize: "14px" }}
                        >
                          {clientData.branch || "-"}
                        </p>
                      </div>{" "}
                      {/* <div className="row">
                        <b className="col-4 col-xs-6">Territory</b>
                        <p
                          className="col-8 col-xs-6 mb-1"
                          style={{ fontSize: "14px" }}
                        >
                          {clientData.territory || "-"}
                        </p>
                      </div>{" "} */}
                      <div className="row">
                        <b className="col-4 col-xs-6">State</b>
                        <p
                          className="col-8 col-xs-6 mb-1"
                          style={{ fontSize: "14px" }}
                        >
                          {clientData.state || "-"}
                        </p>
                      </div>{" "}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="p-3">
            <div>
              <ul className="nav nav-tabs-CT" id="myTabs" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link nav-itm-CT tab-item ${
                      activeTab === "personal" ? "active" : ""
                    }`}
                    id="personal"
                    data-bs-toggle="tab"
                    data-bs-target="#personal"
                    type="button"
                    role="tab"
                    aria-controls="personal"
                    aria-selected={activeTab === "personal"}
                    onClick={() => {
                      handleTabClick("personal");
                    }}
                  >
                    Personal
                  </button>
                </li>
                {clientData.type != "CPC" && (
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link nav-itm-CT tab-item ${
                        activeTab === "Equifax" ? "active" : ""
                      }`}
                      data-bs-toggle="tab"
                      data-bs-target="#Equifax"
                      type="button"
                      role="tab"
                      aria-controls="Equifax"
                      aria-selected={activeTab === "Equifax"}
                      onClick={() => handleTabClick("Equifax")}
                    >
                      Equifax
                    </button>
                  </li>
                )}

                {clientData.type != "CPC" && (
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link nav-itm-CT tab-item ${
                        activeTab === "Banking" ? "active" : ""
                      }`}
                      id="Banking"
                      data-bs-toggle="tab"
                      data-bs-target="#Banking"
                      type="button"
                      role="tab"
                      aria-controls="Banking"
                      aria-selected={activeTab === "Banking"}
                      onClick={() => {
                        handleTabClick("Banking");
                      }}
                    >
                      Banking
                    </button>
                  </li>
                )}

                {clientData.type != "CPC" && (
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link nav-itm-CT tab-item ${
                        activeTab === "Credit Appraisal" ? "active" : ""
                      }`}
                      id="Credit Appraisal"
                      data-bs-toggle="tab"
                      data-bs-target="#Credit Appraisal"
                      type="button"
                      role="tab"
                      aria-controls="Credit Appraisal"
                      aria-selected={activeTab === "Credit Appraisal"}
                      onClick={() => {
                        handleTabClick("Credit Appraisal");
                      }}
                    >
                      Credit Appraisal
                    </button>
                  </li>
                )}

                {clientData.type != "CPC" && (
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link nav-itm-CT tab-item ${
                        activeTab === "Neighbour verification" ? "active" : ""
                      }`}
                      id="Neighbour verification"
                      data-bs-toggle="tab"
                      data-bs-target="#Neighbour verification"
                      type="button"
                      role="tab"
                      aria-controls="Neighbour verification"
                      aria-selected={activeTab === "Neighbour verification"}
                      onClick={() => {
                        handleTabClick("Neighbour verification");
                      }}
                    >
                      Neighbour verification
                    </button>
                  </li>
                )}

                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link nav-itm-CT tab-item ${
                      activeTab === "Limit assigned" ? "active" : ""
                    }`}
                    id="Limit assigned"
                    data-bs-toggle="tab"
                    data-bs-target="#Limit assigned"
                    type="button"
                    role="tab"
                    aria-controls="Limit assigned"
                    aria-selected={activeTab === "Limit assigned"}
                    onClick={() => {
                      handleTabClick("Limit assigned");
                    }}
                  >
                    Limit assigned
                  </button>
                </li>

                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link nav-itm-CT tab-item ${
                      activeTab === "Documents" ? "active" : ""
                    }`}
                    id="Documents"
                    data-bs-toggle="tab"
                    data-bs-target="#Documents"
                    type="button"
                    role="tab"
                    aria-controls="Documents"
                    aria-selected={activeTab === "Documents"}
                    onClick={() => {
                      handleTabClick("Documents");
                    }}
                  >
                    Documents
                  </button>
                </li>

                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link nav-itm-CT tab-item ${
                      activeTab === "Remark" ? "active" : ""
                    }`}
                    id="Remark"
                    data-bs-toggle="tab"
                    data-bs-target="#Remark"
                    type="button"
                    role="tab"
                    aria-controls="Remark"
                    aria-selected={activeTab === "Remark"}
                    onClick={() => {
                      handleTabClick("Remark");
                    }}
                  >
                    Remark
                  </button>
                </li>

                {clientData.type != "CPC" && (
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link nav-itm-CT tab-item ${
                        activeTab === "Contact" ? "active" : ""
                      }`}
                      id="Contact"
                      data-bs-toggle="tab"
                      data-bs-target="#Contact"
                      type="button"
                      role="tab"
                      aria-controls="Contact"
                      aria-selected={activeTab === "Contact"}
                      onClick={() => {
                        handleTabClick("Contact");
                      }}
                    >
                      Contact
                    </button>
                  </li>
                )}
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link nav-itm-CT tab-item ${
                      activeTab === "Legal" ? "active" : ""
                    }`}
                    id="Legal"
                    data-bs-toggle="tab"
                    data-bs-target="#Legal"
                    type="button"
                    role="tab"
                    aria-controls="Legal"
                    aria-selected={activeTab === "Legal"}
                    onClick={() => {
                      handleTabClick("Legal");
                    }}
                  >
                    Legal
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link nav-itm-CT tab-item ${
                      activeTab === "Geo" ? "active" : ""
                    }`}
                    id="Geo"
                    data-bs-toggle="tab"
                    data-bs-target="#Geo"
                    type="button"
                    role="tab"
                    aria-controls="Geo"
                    aria-selected={activeTab === "Geo"}
                    onClick={() => {
                      handleTabClick("Geo");
                    }}
                  >
                    Geo Location
                  </button>
                </li>
              </ul>
            </div>
            {activeTab === "personal" && (
              <div
                className={`tab-pane h-100 fade ${
                  activeTab === "personal" ? "show active" : ""
                }`}
                id="personal"
                role="tabpanel"
                aria-labelledby="personal"
              >
                <div className="pt-3">
                  <div className="card">
                    <div className="p-3 pt-4">
                      {isLoader ? (
                        <div className="d-flex justify-content-center">
                          <div
                            className="spinner-border text-success"
                            role="status"
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                        </div>
                      ) : (
                        <div className="table-responsive">
                          <table
                            className="table table-striped m-0"
                            style={{
                              tableLayout: "fixed",
                              border: "none",
                              fontSize: "14px",
                              width: "100%",
                            }}
                          >
                            <tbody>
                              <tr>
                                <th
                                  className="w-50"
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  Name
                                </th>
                                <td
                                  className="text-wrap"
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {PersonalData.name}
                                </td>
                              </tr>
                              <tr>
                                <th
                                  className="w-50"
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  Gender
                                </th>
                                <td
                                  className="text-wrap"
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {PersonalData.gender}
                                </td>
                              </tr>
                              <tr>
                                <th
                                  className="w-50"
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  Date of Birth
                                </th>
                                <td
                                  className="text-wrap"
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {PersonalData.dob}
                                </td>
                              </tr>
                              <tr>
                                <th
                                  className="w-50"
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  UPI Id
                                </th>
                                <td
                                  className="text-wrap"
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {PersonalData.upiId || "-"}
                                </td>
                              </tr>
                              <tr>
                                <th
                                  className="w-50"
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  Bank a/c
                                </th>
                                <td
                                  className="text-wrap"
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {PersonalData.accountNo}
                                </td>
                              </tr>
                              <tr>
                                <th
                                  className="w-50"
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  IFSC Code
                                </th>
                                <td
                                  className="text-wrap"
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {PersonalData.ifsc}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
            {activeTab === "Equifax" && (
              <div
                className={`tab-pane fade ${
                  activeTab === "Equifax" ? "show active" : ""
                }`}
                id="Equifax"
                role="tabpanel"
                aria-labelledby="Equifax"
              >
                <div className="pt-3">
                  <div className="card">
                    <div className="p-3 pt-4">
                      {isLoader ? (
                        <div className="d-flex justify-content-center">
                          <div
                            className="spinner-border text-success"
                            role="status"
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                        </div>
                      ) : (
                        <div className="table-responsive">
                          <table
                            className="table table-striped m-0"
                            style={{
                              tableLayout: "fixed",
                              border: "none",
                              fontSize: "14px",
                              width: "100%",
                            }}
                          >
                            <tbody>
                              <tr>
                                <th
                                  className="w-50"
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  Mobile Number
                                </th>
                                <td
                                  className="text-wrap"
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {eqfexData?.[0]?.mobNumber || "-"}
                                </td>
                              </tr>
                              <tr>
                                <th
                                  className="w-50"
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  Score
                                </th>
                                <td
                                  className="text-wrap"
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {eqfexData?.[0]?.score || "-"}
                                </td>
                              </tr>
                              <tr>
                                <th
                                  className="w-50"
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  Entry Date
                                </th>
                                <td
                                  className="text-wrap"
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {eqfexData?.[0]?.entrydate || "-"}
                                </td>
                              </tr>
                              <tr>
                                <th
                                  className="w-50"
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  Response
                                </th>
                                <td
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  <button
                                    className="btn btn-primary"
                                    style={{ width: "100px" }}
                                    onClick={() =>
                                      openJSON(eqfexData?.[0]?.response)
                                    }
                                  >
                                    JSON
                                  </button>
                                </td>
                              </tr>
                              <tr>
                                <th
                                  className="w-50"
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  Live Loan
                                </th>
                                <td
                                  className="text-wrap"
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {eqfexData?.[0]?.liveLoan || "-"}
                                </td>
                              </tr>
                              <tr>
                                <th
                                  className="w-50"
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  Overdue
                                </th>
                                <td
                                  className="text-wrap"
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {JSON.stringify(eqfexData?.[0]?.overdue) ||
                                    "-"}
                                </td>
                              </tr>
                              <tr>
                                <th
                                  className="w-50"
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  Write-off Amount
                                </th>
                                <td
                                  className="text-wrap"
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {eqfexData?.[0]?.writeofamount || "-"}
                                </td>
                              </tr>
                              <tr>
                                <th
                                  className="w-50"
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  6-Month Delay
                                </th>
                                <td
                                  className="text-wrap"
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {JSON.stringify(
                                    eqfexData?.[0]?.sixmonthdelay
                                  ) || "-"}
                                </td>
                              </tr>
                              <tr>
                                <th
                                  className="w-50"
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  NTC
                                </th>
                                <td
                                  className="text-wrap"
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {JSON.stringify(eqfexData?.[0]?.ntc) || "-"}
                                </td>
                              </tr>
                              <tr>
                                <th
                                  className="w-50"
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  Overdue Amount
                                </th>
                                <td
                                  className="text-wrap"
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {JSON.stringify(
                                    eqfexData?.[0]?.overdueamount
                                  ) || "-"}
                                </td>
                              </tr>
                              <tr>
                                <th
                                  className="w-50"
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  Old Customer
                                </th>
                                <td
                                  className="text-wrap"
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {eqfexData?.[0]?.oldCustomer || "-"}
                                </td>
                              </tr>

                              {/* Dynamic Document Links */}
                              {eqfexData?.map(
                                (item, i) =>
                                  item.docUrl && (
                                    <tr key={i}>
                                      <td colSpan="2">
                                        <a
                                          href={item.docUrl}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          {item.docName || "Document"}
                                        </a>
                                      </td>
                                    </tr>
                                  )
                              )}
                            </tbody>
                          </table>
                        </div>
                      )}{" "}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "Banking" && (
              <div
                className={`tab-pane fade ${
                  activeTab === "Banking" ? "show active" : ""
                }`}
                id="Banking"
                role="tabpanel"
                aria-labelledby="Banking"
              >
                <div className="p-3">
                  <div className="card">
                    <div className="p-3 pt-4">
                      {isLoader ? (
                        <div className="d-flex justify-content-center">
                          <div
                            className="spinner-border text-success"
                            role="status"
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                        </div>
                      ) : (
                        <div className="table-responsive">
                          <table
                            className="table table-striped m-0"
                            style={{
                              tableLayout: "fixed",
                              border: "none",
                              fontSize: "14px",
                              width: "100%",
                            }}
                          >
                            <tbody>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                  }}
                                  className="w-50"
                                >
                                  Request Id
                                </th>
                                <th
                                  className="text-wrap"
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.requestId || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  Txn Id
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.txnId || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  TrxnDetailsJson
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.trxnDetailsJson || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  TxnMsg
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.txnMsg || "-"}
                                </th>
                              </tr>
                              {/* <tr>
                              <th
                                style={{
                                  border: "none",
                                  fontSize: "14px",
                                  width: "250px",
                                }}
                              >
                                Status
                              </th>
                              <th style={{ border: "none", fontSize: "14px" }}>
                                {bankData?.status || "-"}
                              </th>
                            </tr> */}
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  EntryBy
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.entryBy || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  EntryDate
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.entryDate || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  ClientMobileNo
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.clientMobileNo || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th style={{ border: "none" }}>Response</th>
                                <th style={{ border: "none" }}>
                                  <button
                                    className="btn btn-outline-primary"
                                    style={{ width: "100px" }}
                                    onClick={() =>
                                      openJSON(bankData.responsejson || {})
                                    }
                                  >
                                    View
                                  </button>
                                </th>
                              </tr>
                              {/* <tr>
                              <th
                                style={{
                                  border: "none",
                                  fontSize: "14px",
                                  width: "250px",
                                }}
                              >
                                AggregatorResponse
                              </th>
                              <th style={{ border: "none", fontSize: "14px" }}>
                                {bankData?.aggregatorResponse || "-"}
                              </th>
                            </tr>
                            <tr>
                              <th
                                style={{
                                  border: "none",
                                  fontSize: "14px",
                                  width: "250px",
                                }}
                              >
                                JsonStatus
                              </th>
                              <th style={{ border: "none", fontSize: "14px" }}>
                                {bankData?.jsonStatus || "-"}
                              </th>
                            </tr>
                            <tr>
                              <th
                                style={{
                                  border: "none",
                                  fontSize: "14px",
                                  width: "250px",
                                }}
                              >
                                FirstMonthSalary
                              </th>
                              <th style={{ border: "none", fontSize: "14px" }}>
                                {bankData?.firstMonthSalary || "-"}
                              </th>
                            </tr>
                            <tr>
                              <th
                                style={{
                                  border: "none",
                                  fontSize: "14px",
                                  width: "250px",
                                }}
                              >
                                SecondMonthSalary
                              </th>
                              <th style={{ border: "none", fontSize: "14px" }}>
                                {bankData?.secondMonthSalary || "-"}
                              </th>
                            </tr>
                            <tr>
                              <th
                                style={{
                                  border: "none",
                                  fontSize: "14px",
                                  width: "250px",
                                }}
                              >
                                ThirdMonthSalary
                              </th>
                              <th style={{ border: "none", fontSize: "14px" }}>
                                {bankData?.thirdMonthSalary || "-"}
                              </th>
                            </tr> */}
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  AverageEodBalance
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.averageEodBalance || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  LoanDisbursal
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.loanDisbursal || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  MaxBalance
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.maxBalance || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  MinBalance
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.minBalance || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  MaxEodBalance
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.maxEodBalance || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  MedianEodBalance
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.medianEodBalance || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  MinEodBalance
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.minEodBalance || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  NoOfEmiByLoanPayments
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.noOfEmiByLoanPayments || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  StartDate
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.startDate || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  SumOfIByWBounced
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.sumOfIByWBounced || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  TotalAmountOfCashDeposits
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.totalAmountOfCashDeposits || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  TotalAmountOfCashWithdrawals
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.totalAmountOfCashWithdrawals ||
                                    "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  TotalAmountOfChequeDeposits
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.totalAmountOfChequeDeposits || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  TotalAmountOfChequeIssues
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.totalAmountOfChequeIssues || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  TotalAmountOfCreditTransactions
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.totalAmountOfCreditTransactions ||
                                    "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  TotalAmountOfDebitTransactions
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.totalAmountOfDebitTransactions ||
                                    "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  TotalAmountOfEmiByLoanPayments
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.totalAmountOfEmiByLoanPayments ||
                                    "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  TotalAmountOfIByWChequeBounceNonTechnical
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.totalAmountOfIByWChequeBounceNonTechnical ||
                                    "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  TotalAmountOfLoanDisbursal
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.totalAmountOfLoanDisbursal || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  TotalNoOfSalaryCreditsOneEightyDays
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.totalNoOfSalaryCreditsOneEightyDays ||
                                    "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  TotalNoOfCashDeposits
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.totalNoOfCashDeposits || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  TotalNoOfCashWithdrawals
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.totalNoOfCashWithdrawals || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  TotalNoOfChequeDeposits
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.totalNoOfChequeDeposits || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  TotalNoOfChequeIssues
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.totalNoOfChequeIssues || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  TotalNoOfCreditTransactions
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.totalNoOfCreditTransactions || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  TotalNoOfDebitTransactions
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.totalNoOfDebitTransactions || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  TotalNoOfEmiByLoanPayments
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.totalNoOfEmiByLoanPayments || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  TotalNoOfIByWChequeBounceNonTechnical
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.totalNoOfIByWChequeBounceNonTechnical ||
                                    "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  TotalNoOfIByWChqBounced
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.totalNoOfIByWChqBounced || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  TotalNoOfIByWBounced
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.totalNoOfIByWBounced || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  TotalNoOfLoanDisbursal
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.totalNoOfLoanDisbursal || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  TotalNumberOfOutwardChequeBounces
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.totalNumberOfOutwardChequeBounces ||
                                    "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  TotalAmountOfIByWBounced
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.totalAmountOfIByWBounced || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  ChqDeposits
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.chqDeposits || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  ChqIssues
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.chqIssues || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  InwChqBounceNonTechnical
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.inwChqBounceNonTechnical || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  LoanDisbursals
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.loanDisbursals || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  TotalChqDeposits
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.totalChqDeposits || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  TotalChqIssues
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.totalChqIssues || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  TotalLoanDisbursal
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.totalLoanDisbursal || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  DataSource
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.dataSource || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  ReturnUrlStatus
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.returnUrlStatus || "-"}
                                </th>
                              </tr>

                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  Name
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.name || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  NipStatus
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.nipStatus || "-"}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  Accountno
                                </th>
                                <th
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {bankData?.accountno || "-"}
                                </th>
                              </tr>

                              <tr>
                                {" "}
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                    width: "250px",
                                  }}
                                >
                                  <a href={bankData.s3Path}>Bank Statement</a>
                                </th>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      )}{" "}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "Credit Appraisal" && (
              <div
                className={`tab-pane fade ${
                  activeTab === "Credit Appraisal" ? "show active" : ""
                }`}
                id="Credit Appraisal"
                role="tabpanel"
                aria-labelledby="Credit Appraisal"
              >
                <div className="pt-3">
                  <div className="card">
                    <div className="p-3 pt-4">
                      <div
                        style={{
                          fontFamily: "PostGrotesk",
                          borderRadius: "10px",
                        }}
                      >
                        <div className="row mt-3">
                          <div className="col-lg-4 col-md-4 col-sm-12">
                            <div
                              className=""
                              style={{
                                borderRadius: "0px",
                                border: "2px solid #CACACA",
                              }}
                            >
                              <h5 className="p-2">Loan Details</h5>
                              <hr />
                              <table
                                className="table table-striped m-0"
                                style={{
                                  tableLayout: "fixed",
                                  border: "none",
                                }}
                              >
                                <tbody>
                                  {/* <tr>
                                      <th style={{ border: "none" }}>
                                        Branch ID
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.branchId}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Loan Id
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data?.loanid}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Client Id
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data?.enrollmentid}
                                      </th>
                                    </tr> */}
                                  <tr>
                                    <th
                                      style={{
                                        border: "none",
                                        padding: "10px",
                                      }}
                                    >
                                      Sanction Amount
                                    </th>
                                    <th
                                      style={{
                                        border: "none",
                                        padding: "10px",
                                        display: "flex",
                                        justifyContent: "space-between", // Pushes text left & button right
                                        alignItems: "center", // Vertically aligns content
                                        gap: "10px", // Adds spacing between text & button
                                      }}
                                    >
                                      <span>{data?.sanctionAmount}</span>
                                    </th>
                                  </tr>

                                  {/* <tr>
                                      <th style={{ border: "none" }}>
                                        Scheme No
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data?.schemeNo}
                                      </th>
                                    </tr> */}
                                  {/* <tr>
                                      <th style={{ border: "none" }}>
                                        Product
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data?.product}
                                      </th>
                                    </tr> */}
                                  {/* <tr>
                                      <th style={{ border: "none" }}>Period</th>
                                      <th style={{ border: "none" }}>
                                        {data?.period}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>EMI</th>
                                      <th style={{ border: "none" }}>
                                        {data?.emi}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Equifax 360
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.score}
                                      </th>
                                    </tr> */}
                                  <tr>
                                    <th style={{ border: "none" }}>Pincode</th>
                                    <th style={{ border: "none" }}>
                                      {data.pincode}
                                    </th>
                                  </tr>
                                  {/* <tr>
                                      <th style={{ border: "none" }}>E-Mail</th>
                                      <th style={{ border: "none" }}>
                                        {data.emailid}
                                      </th>
                                    </tr> */}
                                  {/* <tr>
                                      <th style={{ border: "none" }}>
                                        Date Of Exit
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.dateofexit}
                                      </th>
                                    </tr> */}

                                  <tr>
                                    <th style={{ border: "none" }}>
                                      Entry Date
                                    </th>
                                    <th style={{ border: "none" }}>
                                      {moment(data.entryDate).format(
                                        "DD/MM/YYYY hh:mm:ss A"
                                      )}
                                    </th>
                                  </tr>
                                  {/* <tr>
                                      <th style={{ border: "none" }}>
                                        Account Number
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data?.clientaccountno}
                                      </th>
                                    </tr> */}
                                  <tr></tr>

                                  <tr>
                                    <th style={{ border: "none" }}>
                                      Branch Name
                                    </th>
                                    <th style={{ border: "none" }}>
                                      {data.branchName}
                                    </th>
                                  </tr>

                                  <tr>
                                    <th style={{ border: "none" }}>
                                      Client Add Latitude
                                    </th>
                                    <th style={{ border: "none" }}>
                                      {data.clientAddressLat}
                                    </th>
                                  </tr>

                                  <tr>
                                    <th style={{ border: "none" }}>
                                      Client Add Longitude
                                    </th>
                                    <th style={{ border: "none" }}>
                                      {data.clientAddressLong}
                                    </th>
                                  </tr>
                                  <tr>
                                    <th style={{ border: "none" }}>
                                      Branch Latitude
                                    </th>
                                    <th style={{ border: "none" }}>
                                      {data.branchLat}
                                    </th>
                                  </tr>
                                  <tr>
                                    <th style={{ border: "none" }}>
                                      Branch Longitude
                                    </th>
                                    <th style={{ border: "none" }}>
                                      {data.branchLong}
                                    </th>
                                  </tr>
                                  {/* <tr>
                                      <th style={{ border: "none" }}>
                                        Brnach Type
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.branchType}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Client Dist
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.clientDist}
                                      </th>
                                    </tr> */}
                                  <tr>
                                    <th style={{ border: "none" }}>
                                      Office Pincode
                                    </th>
                                    <th style={{ border: "none" }}>
                                      {data.officeaddress}
                                    </th>
                                  </tr>
                                  {/* <tr>
                                      <th style={{ border: "none" }}>
                                        Client Account No
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.clientaccountno}
                                      </th>
                                    </tr> */}

                                  <tr>
                                    <th style={{ border: "none" }}>
                                      Client Distance
                                    </th>
                                    <th style={{ border: "none" }}>
                                      {data.clientDist || "-"}
                                    </th>
                                  </tr>
                                  <tr>
                                    <th style={{ border: "none" }}>
                                      GEO LOCATION
                                    </th>
                                    <th style={{ border: "none" }}>
                                      <button
                                        className="btn btn-primary"
                                        role="tab"
                                        style={{ textDecoration: "none" }}
                                        onClick={groLocation}
                                      >
                                        GEOLOCATION
                                      </button>
                                    </th>
                                  </tr>
                                </tbody>
                              </table>
                              <div className="mt-3">
                                <span className="fw-bold ms-2">
                                  Borrower KYC Address :-
                                </span>
                                <br />
                                <div
                                  className="ms-3"
                                  style={{ fontSize: "18px" }}
                                >
                                  <span>
                                    {data.clienthouseno && (
                                      <span>{data.clienthouseno}, </span>
                                    )}
                                    {data.clientstreet && (
                                      <span>{data.clientstreet}, </span>
                                    )}
                                    {data.clientlocality && (
                                      <span>{data.clientlocality}, </span>
                                    )}
                                    {data.clientlandmark && (
                                      <span>{data.clientlandmark}, </span>
                                    )}
                                    {data.clienttown && (
                                      <span>{data.clienttown}, </span>
                                    )}
                                    {data.clientpostoffice && (
                                      <span>{data.clientpostoffice}, </span>
                                    )}
                                    {data.clientsubdistrict && (
                                      <span>{data.clientsubdistrict}, </span>
                                    )}
                                    {data.clientdistrict && (
                                      <span>{data.clientdistrict}, </span>
                                    )}
                                    {data.clientstate && (
                                      <span>{data.clientstate}, </span>
                                    )}
                                    {data.clientpincode && (
                                      <span>{data.clientpincode}</span>
                                    )}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div
                              className="mt-2"
                              style={{
                                borderRadius: "0px",
                                border: "2px solid #CACACA",
                              }}
                            >
                              <h5 className="p-2">Account Aggregator</h5>
                              <hr />
                              <table
                                className="table table-striped m-0"
                                style={{
                                  tableLayout: "fixed",
                                  border: "none",
                                }}
                              >
                                <tbody>
                                  <tr>
                                    <th style={{ border: "none" }}>
                                      Account No
                                    </th>
                                    <th style={{ border: "none" }}>
                                      {data.accountno || "-"}
                                    </th>
                                  </tr>
                                  <tr>
                                    <th style={{ border: "none" }}>
                                      Account Aggregator Name
                                    </th>
                                    <th style={{ border: "none" }}>
                                      {data.accountAggregatorName || "-"}
                                    </th>
                                  </tr>
                                  {/* <tr>
                                      <th style={{ border: "none" }}>
                                        First Month Salary
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.firstMonthSalary || "-"}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Second Month Salary
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.secondMonthSalary || "-"}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Third Month Salary
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.thirdMonthSalary || "-"}
                                      </th>
                                    </tr> */}
                                  <tr>
                                    <th style={{ border: "none" }}>
                                      Average Eod Balance
                                    </th>
                                    <th style={{ border: "none" }}>
                                      {data.averageEodBalance || "-"}
                                    </th>
                                  </tr>{" "}
                                  <tr>
                                    <th style={{ border: "none" }}>
                                      Diff Transaction
                                    </th>
                                    <th style={{ border: "none" }}>
                                      {data.diffTransaction || "-"}
                                    </th>
                                  </tr>{" "}
                                  <tr>
                                    <th style={{ border: "none" }}>
                                      Date Of Joining
                                    </th>
                                    <th style={{ border: "none" }}>
                                      {moment(data.dateOfJoining).format(
                                        "DD/MM/YYYY hh:mm:ss A"
                                      )}
                                    </th>
                                  </tr>{" "}
                                  <tr>
                                    <th style={{ border: "none" }}>
                                      Total No Of Credit Transactions
                                    </th>
                                    <th style={{ border: "none" }}>
                                      {data.totalNoOfCreditTransactions || "-"}
                                    </th>
                                  </tr>{" "}
                                  <tr>
                                    <th style={{ border: "none" }}>
                                      Total No Of Debit Transactions
                                    </th>
                                    <th style={{ border: "none" }}>
                                      {data.totalNoOfDebitTransactions || "-"}
                                    </th>
                                  </tr>
                                  <tr>
                                    <th style={{ border: "none" }}>
                                      Account Aggregator Response
                                    </th>
                                    <th style={{ border: "none" }}>
                                      <button
                                        className="btn btn-outline-primary"
                                        onClick={() =>
                                          openJSON(data.responsejson || {})
                                        }
                                      >
                                        Click
                                      </button>
                                    </th>
                                  </tr>
                                  <tr>
                                    <th style={{ border: "none" }}>
                                      Account Aggregator Excel
                                    </th>
                                    <th style={{ border: "none" }}>
                                      <a
                                        href={`https://tap.capitaltrust.in:8083/cashontap/s3pathExcelDownload/${data.appClientId}`}
                                      >
                                        Download
                                      </a>
                                    </th>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div className="col-lg-4 col-md-4 col-sm-12">
                            <div
                              className=""
                              style={{
                                borderRadius: "0px",
                                border: "2px solid #CACACA",
                              }}
                            >
                              <h5 className="p-2">Borrower Details</h5>
                              <hr />
                              <table
                                className="table table-striped m-0"
                                style={{
                                  tableLayout: "fixed",
                                  border: "none",
                                }}
                              >
                                <tbody>
                                  <tr>
                                    <th style={{ border: "none" }}>
                                      App Client Id
                                    </th>
                                    <th style={{ border: "none" }}>
                                      {data.appClientId
                                        ? data.appClientId
                                        : data.appclientid}
                                    </th>
                                  </tr>
                                  <tr>
                                    <th style={{ border: "none" }}>Name</th>
                                    <th style={{ border: "none" }}>
                                      {data.name || data.clientname}
                                    </th>
                                  </tr>
                                  <tr>
                                    <th style={{ border: "none" }}>Gender</th>
                                    <th style={{ border: "none" }}>
                                      {data.gender === "M"
                                        ? "Male"
                                        : data.gender === "F"
                                        ? "Female"
                                        : ""}
                                    </th>
                                  </tr>
                                  <tr>
                                    <th style={{ border: "none" }}>C/O</th>
                                    <th style={{ border: "none" }}>
                                      {data.careOf}
                                    </th>
                                  </tr>
                                  <tr>
                                    <th style={{ border: "none" }}>Relation</th>
                                    <th style={{ border: "none" }}>
                                      {data.relation === "M"
                                        ? "Mother"
                                        : data.relation === "F"
                                        ? "Father"
                                        : data.relation === "H"
                                        ? "Husband"
                                        : data.relation === "W"
                                        ? "Wife"
                                        : ""}
                                    </th>
                                  </tr>
                                  <tr>
                                    <th style={{ border: "none" }}>
                                      Date Of Birth
                                    </th>
                                    <th style={{ border: "none" }}>
                                      {data.dateOfBirth
                                        ? moment(data.dateOfBirth).format(
                                            "DD-MM-YYYY"
                                          )
                                        : ""}
                                    </th>
                                  </tr>
                                  <tr>
                                    <th style={{ border: "none" }}>Mobile</th>
                                    <th style={{ border: "none" }}>
                                      {data.mobile}
                                    </th>
                                  </tr>
                                  <tr>
                                    <th style={{ border: "none" }}>
                                      KYC Aadhar Card
                                    </th>
                                    <th style={{ border: "none" }}>
                                      {data.kycAadhaarNumber || data.kycNumber}
                                    </th>
                                  </tr>
                                  <tr>
                                    <th style={{ border: "none" }}>Ref Name</th>
                                    <th style={{ border: "none" }}>
                                      {data.refName}
                                    </th>
                                  </tr>
                                  <tr>
                                    <th style={{ border: "none" }}>
                                      Ref Mobile
                                    </th>
                                    <th style={{ border: "none" }}>
                                      {data.refMobile}
                                    </th>
                                  </tr>
                                  <tr>
                                    <th style={{ border: "none" }}>
                                      Business Place
                                    </th>
                                    <th style={{ border: "none" }}>
                                      {data.businessPlace}
                                    </th>
                                  </tr>
                                  <tr>
                                    <th style={{ border: "none" }}>
                                      No Of Years Current Location
                                    </th>
                                    <th style={{ border: "none" }}>
                                      {data.noOfYerasCurrentLocation}
                                    </th>
                                  </tr>
                                  <tr>
                                    <th style={{ border: "none" }}>
                                      Overall No Of Years
                                    </th>
                                    <th style={{ border: "none" }}>
                                      {data.overallNoOfYears}
                                    </th>
                                  </tr>
                                  {/* <tr>
                                    <th style={{ border: "none" }}>
                                      Pan Link With Aadhar
                                    </th>
                                    <th style={{ border: "none" }}>
                                      <span>({addharmesg || "-"})</span>
                                    </th>
                                  </tr> */}
                                  {/* <tr>
                                      <th style={{ border: "none" }}>
                                        Employee Type
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.employeeType === 1
                                          ? "Salaried Employee"
                                          : data.employeeType === 2
                                          ? "Self Employee"
                                          : ""}
                                      </th>
                                    </tr> */}
                                  {data.employeeType === 2 && (
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Average Eod Balance
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.averageEodBalance}
                                      </th>
                                    </tr>
                                  )}
                                  {data.employeeType === 2 && (
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Total No of Credit
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.totalNoOfCreditTransactions}
                                      </th>
                                    </tr>
                                  )}
                                  {data.employeeType === 2 && (
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Total No of Debit
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.totalNoOfDebitTransactions}
                                      </th>
                                    </tr>
                                  )}
                                  {/* {data.employeeType === 1 && (
                                      <tr>
                                        <th style={{ border: "none" }}>
                                          Employee Name
                                        </th>
                                        <th style={{ border: "none" }}>
                                          {data.employerName}
                                        </th>
                                      </tr>
                                    )}
                                    {data.employeeType === 1 && (
                                      <tr>
                                        <th style={{ border: "none" }}>
                                          Date Of Joining
                                        </th>
                                        <th style={{ border: "none" }}>
                                          {moment(data.dateOfJoining).format(
                                            "DD-MM-YYYY"
                                          )}
                                        </th>
                                      </tr>
                                    )} */}
                                </tbody>
                              </table>
                            </div>

                            <div
                              className="mt-2"
                              style={{
                                borderRadius: "0px",
                                border: "2px solid #CACACA",
                              }}
                            >
                              <h5 className="p-2">Banking</h5>
                              <hr />
                              <table
                                className="table table-striped m-0"
                                style={{
                                  tableLayout: "fixed",
                                  border: "none",
                                }}
                              >
                                <tbody>
                                  <tr>
                                    <th
                                      style={{
                                        border: "none",
                                        color: "green",
                                      }}
                                    >
                                      UPI Nach Account No
                                    </th>
                                    <th
                                      style={{
                                        border: "none",
                                        color: "green",
                                      }}
                                    >
                                      {data.clientaccountno || "-"}
                                    </th>
                                  </tr>

                                  <tr>
                                    <th
                                      style={{
                                        border: "none",
                                        color: "green",
                                      }}
                                    >
                                      AA account No
                                    </th>
                                    <th
                                      style={{
                                        border: "none",
                                        color: "green",
                                      }}
                                    >
                                      {data.accountno || "-"}
                                    </th>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div
                              className="mt-2"
                              style={{
                                borderRadius: "0px",
                                border: "2px solid #CACACA",
                              }}
                            >
                              <h5 className="p-2">UPI</h5>
                              <hr />
                              <table
                                className="table table-striped m-0"
                                style={{
                                  tableLayout: "fixed",
                                  border: "none",
                                }}
                              >
                                <tbody>
                                  <tr>
                                    <th
                                      style={{
                                        border: "none",
                                        color: "green",
                                      }}
                                    >
                                      Nach UPI ID
                                    </th>
                                    <th
                                      style={{
                                        border: "none",
                                        color: "green",
                                      }}
                                    >
                                      {data.upiId || "-"}
                                    </th>
                                  </tr>

                                  <tr>
                                    <th
                                      style={{
                                        border: "none",
                                        color: "green",
                                      }}
                                    >
                                      QR Code ID
                                    </th>
                                    <th
                                      style={{
                                        border: "none",
                                        color: "green",
                                      }}
                                    >
                                      {pdData?.appUploadUpiId || "-"}
                                    </th>
                                  </tr>
                                </tbody>
                              </table>
                            </div>

                            <div
                              className="mt-2"
                              style={{
                                borderRadius: "0px",
                                border: "2px solid #CACACA",
                              }}
                            >
                              <h5 className="p-2">Name</h5>
                              <hr />
                              <table
                                className="table table-striped m-0"
                                style={{
                                  tableLayout: "fixed",
                                  border: "none",
                                }}
                              >
                                <tbody>
                                  <tr>
                                    <th
                                      style={{
                                        border: "none",
                                        color: "green",
                                      }}
                                    >
                                      ⁠ ⁠⁠AA Name
                                    </th>
                                    <th
                                      style={{
                                        border: "none",
                                        color: "green",
                                      }}
                                    >
                                      {data.accountAggregatorName || "-"}
                                    </th>
                                  </tr>

                                  <tr>
                                    <th
                                      style={{
                                        border: "none",
                                        color: "green",
                                      }}
                                    >
                                      ⁠UPI Nach Account Name
                                    </th>
                                    <th
                                      style={{
                                        border: "none",
                                        color: "green",
                                      }}
                                    >
                                      {data.name || "-"}
                                    </th>
                                  </tr>
                                  <tr>
                                    <th
                                      style={{
                                        border: "none",
                                        color: "green",
                                      }}
                                    >
                                      ⁠⁠QR code name
                                    </th>
                                    <th
                                      style={{
                                        border: "none",
                                        color: "green",
                                      }}
                                    >
                                      {pdData.qrName || "-"}
                                    </th>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div
                              className="mt-2"
                              style={{
                                borderRadius: "0px",
                                border: "2px solid #CACACA",
                              }}
                            >
                              <h5 className="p-2">Moile</h5>
                              <hr />
                              <table
                                className="table table-striped m-0"
                                style={{
                                  tableLayout: "fixed",
                                  border: "none",
                                }}
                              >
                                <tbody>
                                  {/* <tr>
                                <th
                                  style={{
                                    border: "none",
                                    color: "green",
                                  }}
                                >
                                  Borrower Mobile
                                </th>
                                <th
                                  style={{
                                    border: "none",
                                    color: "green",
                                  }}
                                >
                                  {data.mobile || "-"}
                                </th>
                              </tr> */}

                                  <tr>
                                    <th
                                      style={{
                                        border: "none",
                                        color: "green",
                                      }}
                                    >
                                      UPI Mobile No
                                    </th>
                                    <th
                                      style={{
                                        border: "none",
                                        color: "green",
                                      }}
                                    >
                                      {pdData?.upiMobileNo || "-"}
                                    </th>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>

                          <div className="col-lg-4 col-md-4 col-sm-12">
                            {/* <div
                              className=""
                              style={{
                                borderRadius: "0px",
                                border: "2px solid #CACACA",
                              }}
                            >
                              <h5 className="p-2">PD Details</h5>
                              <hr />
                              <table
                                className="table table-striped m-0"
                                style={{
                                  tableLayout: "fixed",
                                  border: "none",
                                }}
                              >
                                <tbody>
                                

                                  <tr>
                                    <th style={{ border: "none" }}>
                                      Entry Date
                                    </th>
                                    <th style={{ border: "none" }}>
                                      {moment(pdData.entryDate).format(
                                        "DD/MM/YYYY hh:mm:ss A"
                                      )}
                                    </th>
                                  </tr>

                                  <tr>
                                    <th style={{ border: "none" }}>PD By</th>
                                    <th style={{ border: "none" }}>
                                      {pdData.staffName} ({pdData.staffId})
                                    </th>
                                  </tr>

                                  <tr>
                                    <th style={{ border: "none" }}>
                                      Neighbour Name
                                    </th>
                                    <th style={{ border: "none" }}>
                                      {pdData.neighbourName}
                                    </th>
                                  </tr>

                                  <tr>
                                    <th style={{ border: "none" }}>
                                      Neighbour Mobile
                                    </th>
                                    <th style={{ border: "none" }}>
                                      {pdData.neighbourMobileNo}
                                    </th>
                                  </tr>

                                  <tr>
                                    <th style={{ border: "none" }}>
                                      Neighbour Feedback
                                    </th>
                                    <th style={{ border: "none" }}>
                                      {pdData.neighbourFeedback}
                                    </th>
                                  </tr>

                                  <tr>
                                    <th style={{ border: "none" }}>
                                      Nature of Business
                                    </th>
                                    <th style={{ border: "none" }}>
                                      {pdData.natureOfBusiness}
                                    </th>
                                  </tr>

                                  <tr>
                                    <th style={{ border: "none" }}>
                                      Business Place
                                    </th>
                                    <th style={{ border: "none" }}>
                                      {pdData.businessPlace || "N/A"}
                                    </th>
                                  </tr>

                                  <tr>
                                    <th style={{ border: "none" }}>
                                      No. of Years at Current Location
                                    </th>
                                    <th style={{ border: "none" }}>
                                      {pdData.noOfYearsCurrentLocation}
                                    </th>
                                  </tr>

                                  <tr>
                                    <th style={{ border: "none" }}>
                                      Overall No. of Years
                                    </th>
                                    <th style={{ border: "none" }}>
                                      {pdData.overallNoOfYears}
                                    </th>
                                  </tr>

                                  <tr>
                                    <th style={{ border: "none" }}>Remark</th>
                                    <th style={{ border: "none" }}>
                                      {pdData.remark}
                                    </th>
                                  </tr>

                                  <tr>
                                    <th style={{ border: "none" }}>Latitude</th>
                                    <th style={{ border: "none" }}>
                                      {pdData.latitude}
                                    </th>
                                  </tr>

                                  <tr>
                                    <th style={{ border: "none" }}>
                                      Longitude
                                    </th>
                                    <th style={{ border: "none" }}>
                                      {pdData.longitude}
                                    </th>
                                  </tr>
                                </tbody>
                              </table>
                            </div> */}
                            <div
                              className="mt-2"
                              style={{
                                borderRadius: "0px",
                                border: "2px solid #CACACA",
                              }}
                            >
                              <h5 className="p-2">Nach Details</h5>
                              <hr />
                              <table
                                className="table table-striped m-0"
                                style={{
                                  tableLayout: "fixed",
                                  border: "none",
                                }}
                              >
                                <tbody>
                                  <tr>
                                    <th style={{ border: "none" }}>UPI Id</th>
                                    <th style={{ border: "none" }}>
                                      {data.upiId || "-"}
                                    </th>
                                  </tr>
                                  <tr>
                                    <th style={{ border: "none" }}>
                                      Upload Status
                                    </th>
                                    <th style={{ border: "none" }}>
                                      {data.nachUploadStatus || "-"}
                                    </th>
                                  </tr>
                                  <tr>
                                    <th style={{ border: "none" }}>
                                      Emandate Bank Name
                                    </th>
                                    <th style={{ border: "none" }}>
                                      {data.emandateBankName || "-"}
                                    </th>
                                  </tr>
                                  <tr>
                                    <th style={{ border: "none" }}>
                                      Emandate Client Name
                                    </th>
                                    <th style={{ border: "none" }}>
                                      {data.emandateClientName || "-"}
                                    </th>
                                  </tr>
                                  <tr>
                                    <th style={{ border: "none" }}>IFSC</th>
                                    <th style={{ border: "none" }}>
                                      {data.accountIfsc || "-"}
                                    </th>
                                  </tr>
                                  <tr>
                                    <th style={{ border: "none" }}>
                                      Customer A/C No
                                    </th>
                                    <th style={{ border: "none" }}>
                                      {data.customerAccountNumber || "-"}
                                    </th>
                                  </tr>
                                  <tr>
                                    <th style={{ border: "none" }}>
                                      A/C Holder Name
                                    </th>
                                    <th style={{ border: "none" }}>
                                      {data.accountHolderName || "-"}
                                    </th>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div
                              className="mt-2"
                              style={{
                                borderRadius: "0px",
                                border: "2px solid #CACACA",
                              }}
                            >
                              <h5 className="p-2">Bank Details</h5>
                              <hr />
                              <table
                                className="table table-striped m-0"
                                style={{
                                  tableLayout: "fixed",
                                  border: "none",
                                }}
                              >
                                <tbody>
                                  <tr>
                                    <th style={{ border: "none" }}>
                                      Bank Name
                                    </th>
                                    <th style={{ border: "none" }}>
                                      {data.bankname || "-"}
                                    </th>
                                  </tr>
                                  <tr>
                                    <th style={{ border: "none" }}>A/C No</th>
                                    <th style={{ border: "none" }}>
                                      {data.clientaccountno || "-"}
                                    </th>
                                  </tr>
                                  <tr>
                                    <th style={{ border: "none" }}>
                                      Bank Branch
                                    </th>
                                    <th style={{ border: "none" }}>
                                      {data.bankBranch || "-"}
                                    </th>
                                  </tr>
                                  <tr>
                                    <th style={{ border: "none" }}>
                                      IFSC Code
                                    </th>
                                    <th style={{ border: "none" }}>
                                      {data.ifscCode || "-"}
                                    </th>
                                  </tr>
                                  <tr>
                                    <th style={{ border: "none" }}>Cheque</th>
                                    <th style={{ border: "none" }}>
                                      {data.cheque || "-"}
                                    </th>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          {/* <div className="col-lg-4 col-md-4 col-sm-12">
                              <div
                                className=""
                                style={{
                                  borderRadius: "0px",
                                  border: "2px solid #CACACA",
                                }}
                              >
                                <h5 className="p-2">Reference Details</h5>
                                <hr />
                                <table
                                  className="table table-striped m-0"
                                  style={{
                                    tableLayout: "fixed",
                                    border: "none",
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Client Name
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.clientName || data.clientname}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Account Aggregator Name
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.accountAggregatorName}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Current Organisation Name
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.currentOrganisationName}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        EPF Name
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.epfName}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Sim Owner Name
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.simOwnerName}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        PAN Name
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.panName}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        First Reference Name
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.firstRefName}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        First Reference Relation
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.firstRefRelation}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        First Reference Contact No
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.firstRefMobile}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Friend Name
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.friendName}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Friend Contact No
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.friendMobileno}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Friend No Of Years
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {data.friendNoOfYears}
                                      </th>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "Neighbour verification" && (
              <div
                className={`tab-pane fade ${
                  activeTab === "Neighbour verification" ? "show active" : ""
                }`}
                id="Neighbour verification"
                role="tabpanel"
                aria-labelledby="Neighbour verification"
              >
                <div className="pt-3">
                  <div className="card">
                    <div className="p-3 pt-4">
                      {isLoader ? (
                        <div className="d-flex justify-content-center">
                          <div
                            className="spinner-border text-success"
                            role="status"
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                        </div>
                      ) : (
                        <div className="table-responsive">
                          <table
                            className="table table-striped m-0"
                            style={{
                              tableLayout: "fixed",
                              border: "none",
                              fontSize: "14px",
                              width: "100%",
                            }}
                          >
                            <tbody>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                  }}
                                >
                                  Name
                                </th>
                                <td
                                  className="text-wrap"
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {neighbourData?.neighbourName || "-"}
                                </td>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                  }}
                                >
                                  Mobile
                                </th>
                                <td
                                  className="text-wrap"
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {neighbourData?.neighbourMobileNo || "-"}
                                </td>
                              </tr>
                              <tr>
                                <th
                                  style={{
                                    border: "none",
                                    fontSize: "14px",
                                  }}
                                >
                                  Feedback
                                </th>
                                <td
                                  className="text-wrap"
                                  style={{ border: "none", fontSize: "14px" }}
                                >
                                  {neighbourData?.neighbourFeedback || "-"}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      )}{" "}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "Limit assigned" && (
              <div
                className={`tab-pane fade ${
                  activeTab === "Limit assigned" ? "show active" : ""
                }`}
                id="Limit assigned"
                role="tabpanel"
                aria-labelledby="Limit assigned"
              >
                <div className="pt-3">
                  <div className="card">
                    <div className="p-3 pt-4">
                      <>
                        <div className="card shadow mt-4 border">
                          <div className="card-body">
                            <div className="accordion" id="accordionExample">
                              {transitionDataMonthly.map(
                                (row, index) =>
                                  !(
                                    row.withdrawamt === 0 &&
                                    row.totaldue === 0 &&
                                    row.paymentrecived === 0
                                  ) && (
                                    <div className="accordion-item" key={index}>
                                      <h2
                                        className="accordion-header"
                                        id={`heading${index}`}
                                      >
                                        <button
                                          className={`accordion-button ${
                                            index === 0 ? "" : "collapsed"
                                          }`}
                                          type="button"
                                          data-bs-toggle="collapse"
                                          data-bs-target={`#collapse${index}`}
                                          aria-expanded={
                                            index === 0 ? "true" : "false"
                                          }
                                          aria-controls={`collapse${index}`}
                                        >
                                          {row?.monthyear}
                                        </button>
                                      </h2>
                                      <div
                                        id={`collapse${index}`}
                                        className={`accordion-collapse collapse ${
                                          index === 0 ? "show" : ""
                                        }`}
                                        aria-labelledby={`heading${index}`}
                                        data-bs-parent="#accordionExample"
                                      >
                                        <div className="accordion-body">
                                          <div className="card-text">
                                            <div className="table-responsive">
                                              <table className="table mt-3">
                                                <tbody>
                                                  <tr>
                                                    <td>Withdrawals</td>
                                                    <td>
                                                      Rs. {row?.withdrawamt}
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <td>Conv fees incl GST</td>
                                                    <td>Rs. {row?.convgst}</td>
                                                  </tr>
                                                  <tr>
                                                    <td>Late Fees</td>
                                                    <td>Rs. {row?.latefee}</td>
                                                  </tr>
                                                  <tr>
                                                    <td>Total Due</td>
                                                    <td>Rs. {row?.totaldue}</td>
                                                  </tr>
                                                  <tr>
                                                    <td>Payments</td>
                                                    <td>
                                                      Rs. {row?.paymentrecived}
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <td>Balance Due</td>
                                                    <td>
                                                      Rs. {row?.balancedue}
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )
                              )}
                            </div>
                          </div>
                        </div>
                      </>

                      <div className="mt-4">
                        <h5 className="text-center">Transaction Status</h5>
                        <div className="table-responsive">
                          <table className="table table-bordered text-center">
                            <thead className="table-success">
                              <tr>
                                <th style={{ whiteSpace: "nowrap" }}>S No.</th>
                                <th style={{ whiteSpace: "nowrap" }}>Date</th>
                                <th style={{ whiteSpace: "nowrap" }}>Payee</th>
                                <th style={{ whiteSpace: "nowrap" }}>
                                  Withdrawal
                                </th>
                                <th style={{ whiteSpace: "nowrap" }}>
                                  Payment
                                </th>
                                <th style={{ whiteSpace: "nowrap" }}>Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              {transitionHistroy.map((tx, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>{tx.Date}</td>
                                  <td>{tx.Name}</td>
                                  <td>Rs. {tx.SucessAmount || "-"}</td>
                                  <td>Rs. {tx.tag || "-"}</td>
                                  <td
                                    className={
                                      tx.Status === "SUCCESS"
                                        ? "text-success fw-bold"
                                        : "text-danger fw-bold"
                                    }
                                  >
                                    {tx.Status}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "Documents" && (
              <div
                className={`tab-pane fade ${
                  activeTab === "Documents" ? "show active" : ""
                }`}
                id="Documents"
                role="tabpanel"
                aria-labelledby="Documents"
              >
                <div className="pt-3">
                  <div className="card">
                    <div className="p-3 pt-4">
                      {isLoader ? (
                        <div className="d-flex justify-content-center">
                          <div
                            className="spinner-border text-success"
                            role="status"
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                        </div>
                      ) : (
                        <>
                          <div className="row justify-content-start mt-2 pb-3">
                            {clientDoc &&
                              clientDoc.map((item, i) => (
                                <div
                                  className="col-6 col-sm-4 col-md-3 col-lg-2 mb-3"
                                  key={i}
                                >
                                  <div
                                    className="card shadow-sm d-flex flex-column justify-content-between"
                                    style={{
                                      width: "100%",
                                      height: "220px",
                                      borderRadius: "8px",
                                      overflow: "hidden",
                                    }}
                                  >
                                    <img
                                      className="card-img-top p-2"
                                      src={item.docUrl}
                                      alt="Document"
                                      style={{
                                        height: "150px",
                                        width: "100%",
                                        objectFit: "contain",
                                        backgroundColor: "#f8f9fa",
                                      }}
                                    />
                                    <a
                                      href={item.docUrl}
                                      className="text-primary font-weight-bold p-2 text-center"
                                      style={{
                                        fontSize: "14px",
                                        textDecoration: "none",
                                        whiteSpace: "normal",
                                        wordBreak: "break-word",
                                        display: "block",
                                      }}
                                    >
                                      {item.docName === "kfsUrl"
                                        ? "KFS"
                                        : item.docName
                                            .replace(/_/g, " ")
                                            .toUpperCase()}
                                    </a>
                                  </div>
                                </div>
                              ))}
                          </div>
                        </>
                      )}{" "}
                    </div>
                  </div>
                </div>
              </div>
            )}
            <Modal
              size="lg"
              show={showModal}
              onHide={handleModalClose}
              style={{ background: "#ffffffc4" }}
            >
              <Modal.Header closeButton>
                <Modal.Title className="font-weight-bold text-primary">
                  GEOLOCATION
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <MapContainer data={mapValue} status={mapStatus} />
              </Modal.Body>
            </Modal>

            {activeTab === "Remark" && (
              <div
                className={`tab-pane fade ${
                  activeTab === "Remark" ? "show active" : ""
                }`}
                id="Remark"
                role="tabpanel"
                aria-labelledby="Remark"
              >
                <div className="pt-3">
                  <div className="card">
                    <div className="p-3 pt-4">
                      <div className="d-flex">
                        <button
                          className="btn btn-primary ml-auto"
                          style={{ width: "100px" }}
                          onClick={() => setShowModalRemark(true)}
                        >
                          Add
                        </button>
                      </div>
                      <div className="table-responsive">
                        <table className="table table-striped mt-3 text-center">
                          <thead className="table-success">
                            <tr>
                              <th style={{ whiteSpace: "nowrap" }}>Sr. No</th>
                              <th style={{ whiteSpace: "nowrap" }}>
                                Remark By
                              </th>
                              <th style={{ whiteSpace: "nowrap" }}>
                                Remark Date
                              </th>
                              <th style={{ whiteSpace: "nowrap" }}>Remark</th>
                            </tr>
                          </thead>
                          <tbody>
                            {remarkData &&
                              remarkData.map((item, i) => (
                                <tr key={i}>
                                  <td>{i + 1}</td>
                                  <td>{item?.remarkby || "-"}</td>
                                  <td>{item?.remarkdate || "-"}</td>
                                  <td
                                    style={{
                                      wordBreak: "break-word",
                                      maxWidth: "300px",
                                    }}
                                  >
                                    {item?.msg || item}
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>

                      <Modal
                        size="lg"
                        show={showModalRemark}
                        onHide={handleModalRemarkClose}
                        style={{ background: "#ffffffc4" }}
                      >
                        <Modal.Header closeButton>
                          <Modal.Title className="font-weight-bold text-primary">
                            Add Remark
                          </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <input
                            type="text"
                            value={staffId}
                            onChange={(e) => setStaffId(e.target.value)}
                            placeholder="Enter Staff ID"
                            style={{
                              width: "100%",
                              padding: "10px",
                              boxSizing: "border-box",
                              border: "1px solid #ccc",
                              borderRadius: "4px",
                              marginTop: "10px",
                              fontSize: "18px",
                            }}
                          />

                          <textarea
                            value={newRemark}
                            rows="4"
                            onChange={(e) => setNewRemark(e.target.value)}
                            placeholder="Enter Remark"
                            style={{
                              width: "100%",
                              padding: "10px",
                              boxSizing: "border-box",
                              border: "1px solid #ccc",
                              borderRadius: "4px",
                              marginTop: "10px",
                              fontSize: "18px",
                            }}
                          />

                          <div className="d-flex mt-3 justify-content-end">
                            <button
                              className="btn btn-secondary"
                              style={{ width: "100px" }}
                              onClick={() => setShowModalRemark(false)}
                            >
                              Cancel
                            </button>
                            <button
                              className="btn btn-success ml-2"
                              style={{ width: "100px", background: "#66a725" }}
                              onClick={handleSubmitRemark}
                            >
                              Submit
                            </button>
                          </div>
                        </Modal.Body>
                      </Modal>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "Contact" && (
              <div
                className={`tab-pane fade ${
                  activeTab === "Contact" ? "show active" : ""
                }`}
                id="Contact"
                role="tabpanel"
                aria-labelledby="Contact"
              >
                <div className="pt-3">
                  <div className="card">
                    <div className="p-3 pt-4">
                      <table
                        className="table table-striped m-0"
                        style={{
                          tableLayout: "fixed",
                          border: "none",
                          fontSize: "14px",
                        }}
                      >
                        <tbody>
                          <tr>
                            <th style={{ border: "none", fontSize: "14px" }}>
                              User Name
                            </th>

                            <th style={{ border: "none", fontSize: "14px" }}>
                              {contectData?.username}
                            </th>
                          </tr>
                          <tr>
                            {" "}
                            <th style={{ border: "none", fontSize: "14px" }}>
                              Device Id
                            </th>
                            <th style={{ border: "none", fontSize: "14px" }}>
                              {contectData?.deviceId}
                            </th>
                          </tr>
                          <tr>
                            <th style={{ border: "none", fontSize: "14px" }}>
                              Contact List
                            </th>
                            <th style={{ border: "none", fontSize: "14px" }}>
                              {contectData?.contactList}
                            </th>
                          </tr>
                          <tr>
                            <th style={{ border: "none", fontSize: "14px" }}>
                              Ip Address
                            </th>
                            <th style={{ border: "none", fontSize: "14px" }}>
                              {contectData?.ipAddress}
                            </th>
                          </tr>
                          <tr>
                            <th style={{ border: "none", fontSize: "14px" }}>
                              Sim MobileNo
                            </th>
                            <th style={{ border: "none", fontSize: "14px" }}>
                              {contectData?.simMobileNo}
                            </th>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {activeTab === "Legal" && (
              <div
                className={`tab-pane fade ${
                  activeTab === "Legal" ? "show active" : ""
                }`}
                id="Legal"
                role="tabpanel"
                aria-labelledby="Legal"
              >
                <div className="pt-3">
                  <div className="card">
                    <div className="p-3 pt-4">
                      <h3>Legal</h3>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "Geo" && (
              <div
                className="tab-pane fade show active"
                id="Geo"
                role="tabpanel"
                aria-labelledby="Geo"
              >
                <div className="pt-3">
                  <Modal
                    size="lg"
                    show={showModals}
                    onHide={handleModalClose}
                    style={{ background: "#ffffffc4" }}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title className="font-weight-bold text-primary">
                        GEOLOCATION
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <MapContainer data={mapValues} status={mapStatuss} />
                    </Modal.Body>
                  </Modal>

                  <div className="card">
                    <div className="p-3 pt-4">
                      <h3>Geo Location</h3>

                      <div className="d-flex gap-3 mt-4">
                        <Button
                          variant="primary"
                          onClick={() => handleGeoClick("latlong", lid)}
                        >
                          LatLong
                        </Button>
                        <Button
                          variant="success"
                          onClick={() =>
                            handleGeoClick("history", clientData.mobile)
                          }
                        >
                          History
                        </Button>
                        <Button
                          variant="warning"
                          onClick={() =>
                            handleGeoClick("latlongapp", clientData.appclientid)
                          }
                        >
                          LatLong App
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
